import { ROUTES } from '../../../routes/routes';
import { CustomerPortal } from '../../../types/customerPortal';

export const withPageIdParam = (route: ROUTES, pageId: string) => `${route}?pageId=${pageId}`;
export const withCustomerPortalIdParam = (route: ROUTES, customerPortal: CustomerPortal) =>
    `${route}?customerPortalId=${customerPortal.id}`;
